import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
//import { useTranslation } from "react-i18next";
import { Card, CardBody } from 'reactstrap';
import Footer from '../../Components/Footer';
import NavBar from '../../Components/NavBar';
import LeftMenu from '../../Components/LeftMenu';
import BreadCrumb from '../../Components/BreadCrumb';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useTranslation } from "react-i18next";

import LanguageDropdown from '../../Components/Common/CompHeaderLanguageDropdown.jsx';
import ProfileDropdown from '../../Components/Common/CompHeaderProfileDropdown';
import { Link } from 'react-router-dom';
//import images
import logoSm from "../../Assets/Images/header/logo-sm.png";
import logoDark from "../../Assets/Images/header/logo-dark.png";
import logoLight from "../../Assets/Images/header/logo-light.png";
import brandLogo from '../../Assets/Images/brand/logo-color712x186.png';
export default function _StandartPage({ children, title }) {

    document.title = title;
    const { t } = useTranslation();

    React.useMemo(() => {
        if ((sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') || true) {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;

        }
    }, [t]);

    const headerContainerStyle = {
        display: 'flex', // Enables flexbox for layout
        width: '100%', // Ensures the header takes full width
        height: '80px', // Example height, adjust as needed
        backgroundColor: '#ffffff', // Example background color
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Optional: Adds a subtle shadow
    };

    const headerContainerLeftSectionStyle = {
        flex: '2', // Takes 2 units of available space
        display: 'flex',
        justifyContent: 'center', // Centers content horizontally
        alignItems: 'center', // Centers content vertically
        backgroundColor: '#fff', // Example background color for left section
        padding: '10px', // Add some padding
    };

    const headerContainerRight1SectionStyle = {
        flex: '1', // Takes 10 units of available space
        display: 'flex',
        justifyContent: 'flex-start', // Aligns content to the right
        alignItems: 'center', // Centers content vertically
        backgroundColor: '#ffffff', // Example background color for right section
        padding: '10px', // Add some padding
        borderBottomColor: '#013682',
        borderBottomStyle: 'solid',
        borderBottomWidth: '5px',
    };

    const headerContainerRight2SectionStyle = {
        flex: '9', // Takes 10 units of available space
        display: 'flex',
        justifyContent: 'flex-end', // Aligns content to the right
        alignItems: 'center', // Centers content vertically
        backgroundColor: '#ffffff', // Example background color for right section
        padding: '10px', // Add some padding
        borderBottomColor: '#013682',
        borderBottomStyle: 'solid',
        borderBottomWidth: '5px',        
    };

    // Optional: Basic styling for content within sections
    const contentTextStyle = {
        margin: '0',
        fontFamily: 'sans-serif',
        color: '#333',
    };

    const bodyContainerStyle = {
        display: 'flex', // Enables flexbox for layout
        width: '100%', // Ensures the header takes full width
        height: 'auto', // Example height, adjust as needed
        backgroundColor: '#ffffff', // Example background color
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Optional: Adds a subtle shadow
    };

    const bodyContainerLeftSectionStyle = {
        flex: '2', // Takes 2 units of available space
        display: 'flex',
        justifyContent: 'top', // Centers content horizontally
        alignItems: 'top', // Centers content vertically
        backgroundColor: '#fff', // Example background color for left section
        padding: '0px 0px 0px 20px', // Add some padding
    };

    const bodyContainerRightSectionStyle = {
        flex: '10', // Takes 10 units of available space
        display: '',
        justifyContent: 'flex-end', // Aligns content to the right
        alignItems: 'center', // Centers content vertically
        backgroundColor: '#fff', // Example background color for right section
        padding: '10px', // Add some padding
    };

    const [isNavExpanded, setIsNavExpanded] = useState(true);

    const toggleNav = () => {
        setIsNavExpanded(!isNavExpanded);
    };

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    // Event handler for when the mouse leaves the span
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <React.Fragment>
            <ToastContainer />
            <Container fluid="l">
                {<>
                    <Row>
                        <Col>
                            <header style={headerContainerStyle}>
                                <div style={isNavExpanded === true ? headerContainerLeftSectionStyle : { display: 'none' }}>
                                    {/* Your content for the left section goes here */}
                                    <span style={contentTextStyle}>
                                        <div className="navbar-brand-box horizontal-logo">
                                            <Link to="/dashboard" className="logo logo-dark">
                                                <span className="logo-lg">
                                                    <img src={brandLogo} alt="" height="80" />
                                                </span>
                                            </Link>

                                        </div>
                                    </span>
                                </div>
                                <div style={headerContainerRight1SectionStyle}>
                                    {/* Your content for the right section goes here */}
                                    <span style={contentTextStyle}>
                                        <div className="d-flex align-items-center">
                                            <span style={isHovered ? { cursor: 'pointer' } : {}} // Conditionally apply 'hovered' class
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={toggleNav}>
                                                <svg viewBox="0 0 24 24" fill="black" width="24px" height="24px" >
                                                    {isNavExpanded ? (
                                                        // Close icon (e.g., an 'X')
                                                        <>
                                                            <path d="M4 6H20M4 12H20M4 18H20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                                        </>
                                                    ) : (
                                                        // Hamburger icon (e.g., three lines)
                                                        <>
                                                            <path d="M4 6H20M4 12H20M4 18H20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                                        </>
                                                    )}
                                                </svg>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                                <div style={headerContainerRight2SectionStyle}>
                                    {/* Your content for the right section goes here */}
                                    <span style={contentTextStyle}>
                                        <div className="d-flex align-items-center">
                                            <LanguageDropdown />
                                            <ProfileDropdown />
                                        </div>
                                    </span>
                                </div>
                            </header>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span style={bodyContainerStyle}>
                                <div style={isNavExpanded === true ? bodyContainerLeftSectionStyle : { display: 'none' }}>
                                    {/* Your content for the left section goes here */}
                                    <span style={contentTextStyle}>
                                        <LeftMenu />
                                    </span>
                                </div>
                                <div style={bodyContainerRightSectionStyle}>
                                    {/* Your content for the right section goes here */}
                                    <span style={contentTextStyle}>
                                        <Col className="col-12 p-4 text-start" style={{ backgroundColor: '#ffffff' }}>
                                            <BreadCrumb title={title} pageTitle="Tatalli" />
                                            {<>
                                                { }
                                            </>}
                                            <Row>
                                                <Col className="mt-4">
                                                </Col>
                                            </Row>

                                            <Card className='border-0'>
                                                <CardBody>
                                                    {children && children}
                                                </CardBody>
                                            </Card>
                                            <Card className='border-0' style={{
                                                position: 'fixed',
                                                bottom: 0,
                                                width: '100%',
                                                textAlign: 'left',
                                                padding: '10px 0',
                                            }}>
                                                <CardBody>
                                                    <Footer />
                                                </CardBody>
                                            </Card>
                                            <Row>
                                                <Col className="mt-2">
                                                    <br />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </span>
                                </div>
                            </span>
                        </Col>
                    </Row>
                </>
                }

            </Container>
        </React.Fragment>
    )

}